/* global window */
import { getCandidateLinkToken, getLegacyUsername } from './rescheduleLink';

// NOT rescheduleToken: that name routes the page into the reschedule flow instead of booking.
const INVITE_TOKEN_PARAM = 'inviteToken';

let verifiedRecruiter = null;

function getInviteToken(search = window.location.search, pathname = window.location.pathname) {
  return getCandidateLinkToken(INVITE_TOKEN_PARAM, search, pathname);
}

// The invite endpoint names the recruiter only for a token it verified.
function setVerifiedRecruiter(email) {
  verifiedRecruiter = email || null;
}

function getCalendarUsername(search = window.location.search, pathname = window.location.pathname) {
  return getInviteToken(search, pathname) ? verifiedRecruiter : getLegacyUsername(search, pathname);
}

export { INVITE_TOKEN_PARAM, getInviteToken, setVerifiedRecruiter, getCalendarUsername };
